import React from "react";
import "./requestCard.scss";
import { Badge } from "components/badge/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faGolfFlagHole, faUsers } from "@fortawesome/pro-regular-svg-icons";
import { ButtonNew as Button} from "components/buttonNew";
// import { NavigationDropdownNew } from "components/navigationDropdownNew/NavigationDropdownNew";
import { useTranslation } from "react-i18next";
import { ICustomerLotteryRequest } from "api/rpc/2024-04/customer/lotteryRequest";
import moment from "moment";
import { useGuestPortalContext } from "../../GuestPortalContext";
import { useWindowSize } from "hooks/useWindowSize/useWindowSize";
import { MOBILE_WIDTH } from "helpers/ScreenSizes";
import { useAppSelector } from "hooks/redux";

interface IProps {
  request: ICustomerLotteryRequest;
  onCancelRequestClick: (id: number) => void;
  onModifyClick: (facility_id: number, course_id: number, date: string, lottery_id: number) => Promise<void>;
}

export default function RequestCard(props: IProps) {
    const { request, onCancelRequestClick, onModifyClick } = props;
    const { t } = useTranslation();
    const { portalState } = useGuestPortalContext();
    const { clientPortalStore } = useAppSelector(store => store);
    const windowSize = useWindowSize();

    const userId = portalState?.guest ? portalState?.guest?.id : clientPortalStore?.user ? clientPortalStore?.user?.id : null;

    return (
        <div className="ui-request-card">
            <div className="ui-request-card-body">
                <div className="ui-request-card-flex-column" style={{flex: 1}}>
                    <p className="ui-request-card-title">{request?.facility_name} <Badge type="warning" size="small">{t("Lottery Request")}</Badge></p>
                    <div className="ui-request-card-flex-row">
                      {request?.allow_time_preference_window ? (
                        <div className="ui-request-card-tag">
                          {moment(request?.start_time_preference_one, "HH:mm")?.subtract(request?.start_time_preference_window, "hour")?.format("LT")} - {moment(request?.start_time_preference_one, "HH:mm")?.add(request?.start_time_preference_window, "hour")?.format("LT")}
                        </div>
                      ) : (
                        <>
                        {request?.start_time_preference_one ? (
                           <div className="ui-request-card-tag">
                           {moment(request?.start_time_preference_one, "HH:mm")?.format("LT")}
                          </div>
                        ) : null}
                        {request?.start_time_preference_two ? (
                           <div className="ui-request-card-tag">
                           {moment(request?.start_time_preference_two, "HH:mm")?.format("LT")}
                          </div>
                        ) : null}
                        {request?.start_time_preference_three ? (
                           <div className="ui-request-card-tag">
                           {moment(request?.start_time_preference_three, "HH:mm")?.format("LT")}
                          </div>
                        ) : null}
                        </>
                      )}
                    <p className="ui-request-card-secondary"> • {moment(request?.date, "YYYY-MM-DD")?.format("ll")}</p>
                    </div>
                   <div className="ui-request-card-divider"></div>
                   <div className="ui-request-card-flex-row">
                    <Badge type="gray" size="small"><FontAwesomeIcon icon={faUsers} className="mr-2"/> {request?.quantity} {request?.quantity > 1 ? t("Players") : t("Player")}</Badge>
                    <Badge type="gray" size="small"><FontAwesomeIcon icon={faGolfFlagHole} className="mr-2"/> {request?.holes} {t("Holes")}</Badge>
                   </div>
                   
                </div>
                {request?.customer_one?.id !== userId ? (
                  <div className="ui-request-card-requester-container">
                    {windowSize.width <= MOBILE_WIDTH ? (
                      <p className="ui-request-card-secondary ui-request-card-requester">{t("Requested by")} {request?.customer_one?.full_name}</p>
                    ) : (
                      <Badge type="gray" size="medium">{t("Requested by")} {request?.customer_one?.full_name}</Badge>
                    )}  
                    
                    </div>
                   ) : (
                    <div className="ui-request-card-flex-row ui-request-card-actions-container">
                      {moment()?.isAfter(moment(request?.close_date, "YYYY-MM-DD"), 'day') ? (
                        windowSize.width <= MOBILE_WIDTH ? (
                          <div className="ui-request-card-requester-container">
                          <p className="ui-request-card-secondary ui-request-card-requester" style={{color: "#B42318"}}>{t("Submission Deadline Passed")}</p>
                          </div>
                        ) : (
                          <Badge type="error" size="medium">{t("Submission Deadline Passed")}</Badge>
                        )
                      ) : (
                        <Button size={windowSize.width <+ MOBILE_WIDTH ? "small" : "medium"} type="primary" onClick={() => onModifyClick(request?.facility_id, request?.course_id, request?.date, request?.lottery_id)}>{t("Modify")}</Button>
                      )}
                      <Button type="text" size={windowSize.width <+ MOBILE_WIDTH ? "small" : "medium"}><FontAwesomeIcon icon={faBan} onClick={() => onCancelRequestClick(request?.id)} /></Button>
                    {/* <NavigationDropdownNew
                    showPlainTextLabel
                    rightAlign
                    label={<Button size={windowSize.width <+ MOBILE_WIDTH ? "small" : "medium"} type="secondary"><FontAwesomeIcon icon={faEllipsisV} /></Button>}
                    sections={[
                      [
                        {
                          icon: "ban",
                          label: t("Cancel Request"),
                          onClick:  () => onCancelRequestClick(request?.id),
                        },
                      ],
                    ]}
                  /> */}
                </div>
                   )}
 
            </div>
        </div>
    );
}